import { render, staticRenderFns } from "./ManageFooter.vue?vue&type=template&id=0a80d04b&scoped=true"
import script from "./ManageFooter.vue?vue&type=script&lang=js"
export * from "./ManageFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80d04b",
  null
  
)

export default component.exports